// App.js - Add Freelancer import and route
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import './App.css';
// Pages / Components
import Home from './components/Home';
import HomeLoan from './components/HomeLoan';
import PersonalLoan from './components/PersonalLoan';
import LoanAgainstProperty from './components/LoanAgainstProperty';
import BusinessLoan from './components/BusinessLoan';
import CarLoan from './components/CarLoan';
import EducationLoan from './components/EducationLoan';
import InstaLoan from './components/InstaLoan';
import Career from './components/Career';
import Help from './components/Help';
import About from './components/About';
import Cibil from './components/Cibil';
import Coming from './components/Coming';
import YearsExperience from './components/YearsExperience';
import Freelancer from './components/Freelancer';  // ← ADD THIS IMPORT

import Layout from './layout';
import AppToast from './common/toaster';
import BankingPartner from './components/BankingPartner';
import SatisfiedCustomers from './components/SatisfiedCustomer';

function App() {
  return (
    <Router>
      <Layout>
        <AppToast />
        <div className="App">
          <Routes>
            {/* Home is the root route */}
            <Route path="/" element={<Home />} />

            {/* Redirect old /home to root */}
            <Route path="/home" element={<Navigate to="/" replace />} />

            {/* Loan Pages */}
            <Route path="/home-loan" element={<HomeLoan />} />
            <Route path="/personal-loan" element={<PersonalLoan />} />
            <Route path="/loan-against-property" element={<LoanAgainstProperty />} />
            <Route path="/business-loan" element={<BusinessLoan />} />
            <Route path="/car-loan" element={<CarLoan />} />
            <Route path="/education-loan" element={<EducationLoan />} />
            <Route path="/insta-loan" element={<InstaLoan />} />

            {/* Other Pages */}
            <Route path="/career" element={<Career />} />
            <Route path="/help" element={<Help />} />
            <Route path="/about" element={<About />} />
            <Route path="/cibil" element={<Cibil />} />
            <Route path="/year-experience" element={<YearsExperience />} />
            <Route path="/satisfied-customers" element={<SatisfiedCustomers />} />
            {/* <Route path="/coming" element={<Coming />} /> */}
            <Route path="*" element={<Coming />} />

            {/* NEW - Lending Partners page */}
            <Route path="/banking-partners" element={<BankingPartner />} />

            {/* NEW - Freelancer page */}
            <Route path="/freelancers" element={<Freelancer />} />  {/* ← ADD THIS ROUTE */}

          </Routes>
        </div>
      </Layout>
    </Router>
  );
}

export default App;